export const colors = {
  white: `#fffaf8`,
  black: `#16211f`,
  mintBlue: `#45d8c3`,
  darkPlum: `#330e30`,
  lightCharcol: `#474c4c`,
  brightRed: `#ea1c1c`,
}
